export default __webpack_public_path__ + "static/B40-5bc5bf3eee7e92d698d84178f5d8405d.png";